const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://api.estatecoin.in";

export const API_BASE_URL = API_BASE;
export { API_BASE };
export default API_BASE;
